import Request from '../../../../src/core/gd/data/request'

export default class ApiChatV2 {

    // static create(projectId:string, noteTypeId:string, name:String, accessRead:number, accessWrite:number) {
    //     return new Request(this, 'POST', 'document/create', {
    //         projectId   : projectId,
    //         noteTypeId  : noteTypeId,
    //         name        : name,
    //         accessRead  : accessRead,
    //         accessWrite : accessWrite
    //     });
    // }

    static reactionAdd(chatRoomId: ID, chatMessageId:ID, reactionType:number) {
        return new Request(this, 'POST', 'chat/' + chatRoomId + '/message/' + chatMessageId + '/reactions', {
            reactionType: reactionType
        });
    }

    static reactionDelete(chatRoomId: ID, chatMessageId:ID, reactionType:number) {
        return new Request(this, 'DELETE', 'chat/' + chatRoomId + '/message/' + chatMessageId + '/reactions?reactionType='+reactionType)
    }


    static resetChatRooms() {
        return new Request(this, 'GET', 'session/reset-chat-rooms')
    }
}